import { Injectable } from '@angular/core';
import { HttpUtilityService } from './http-utility.service';
import { map, Observable } from 'rxjs';
import { HttpHeaders, HttpParams, HttpResponse } from '@angular/common/http';
import { apiEndpoints } from '../constants/api-endpoints';
import {
  CrewResponse,
  CrewTypeResponse,
  ExportToExcel,
  ScheduleJobsDivisionResponse,
  UnitsByDivisionRequest,
  UnitsByDivisionResponse,
  ViewSchedules,
} from '../interface/maint-schedule-jobs';

@Injectable({
  providedIn: 'root',
})
export class MaintScheduleJobsService {
  constructor(private readonly httpUtilityService: HttpUtilityService) {}

  getMonday(date: Date): Date {
    const day = date.getDay();
    const diff = day >= 1 ? day - 1 : 6;
    const monday = new Date(date);
    monday.setDate(date.getDate() - diff);
    return monday;
  }

  public getScheduleJobsDivision(
    facID: string
  ): Observable<ScheduleJobsDivisionResponse[]> {
    let url = '';
    if (facID) {
      url = `${apiEndpoints.scheduleJobsDivision}?facID=${facID}&eamMode=MX`;
    } else {
      url = apiEndpoints.scheduleJobsDivision;
    }
    return this.httpUtilityService
      .get<HttpResponse<ScheduleJobsDivisionResponse[]>>(url, {
        observe: 'response',
      })
      .pipe(
        map((response: HttpResponse<ScheduleJobsDivisionResponse[]>) => {
          return response.body || [];
        })
      );
  }

  public getUnitsByDivision(
    data: UnitsByDivisionRequest | null
  ): Observable<UnitsByDivisionResponse[]> {
    const url = apiEndpoints.scheduleJobsUnitsByDivision;
    return this.httpUtilityService
      .post<HttpResponse<UnitsByDivisionResponse[]>>(url, data, {
        observe: 'response',
      })
      .pipe(
        map((response: HttpResponse<UnitsByDivisionResponse[]>) => {
          return response.body || [];
        })
      );
  }

  public getScheduleJobsCrewType(
    facID: string
  ): Observable<CrewTypeResponse[]> {
    let url = '';
    if (facID) {
      url = `${apiEndpoints.scheduleJobsCrewType}?facID=${facID}&eamMode=MX`;
    } else {
      url = apiEndpoints.scheduleJobsCrewType;
    }
    return this.httpUtilityService
      .get<HttpResponse<CrewTypeResponse[]>>(url, { observe: 'response' })
      .pipe(
        map((response: HttpResponse<CrewTypeResponse[]>) => {
          return response.body || [];
        })
      );
  }

  public getScheduleJobsCrew(
    facID: string | null,
    crewType: string | null
  ): Observable<CrewResponse[]> {
    let url = '';
    if (!!facID && !!crewType) {
      url = `${apiEndpoints.scheduleJobsCrew}?facID=${facID}&crewType=${crewType}&eamMode=MX`;
    } else if (facID) {
      url = `${apiEndpoints.scheduleJobsCrew}?facID=${facID}&eamMode=MX`;
    } else {
      url = `${apiEndpoints.scheduleJobsCrew}`;
    }
    return this.httpUtilityService
      .get<HttpResponse<CrewResponse[]>>(url, { observe: 'response' })
      .pipe(
        map((response: HttpResponse<CrewResponse[]>) => {
          return response.body || [];
        })
      );
  }

  public getScheduledJobsViewWeeklyScheduleMX(
    data: ExportToExcel
  ): Observable<ViewSchedules | null> {
    const url = apiEndpoints.scheduledJobsViewWeeklyScheduleMX;
    return this.httpUtilityService
      .post<HttpResponse<ViewSchedules>>(url, data, { observe: 'response' })
      .pipe(
        map((response: HttpResponse<ViewSchedules>) => {
          return response.body || null;
        })
      );
  }

  public getScheduledJobsGetmaximoLink(
    wonum: string,
    facId: string,
    sMxSchApp?: string
  ): Observable<HttpResponse<string>> {
    const url = apiEndpoints.scheduledJobsGetmaximoLink;
    let params = new HttpParams()
      .set('workOrderNumber', wonum)
      .set('facId', facId);

    if (sMxSchApp !== undefined) {
      params = params.set('sMxSchApp', sMxSchApp);
    }
    return this.httpUtilityService.get<HttpResponse<string>>(url, {
      params,
    });
  }

  exportWeeklySchedule(data: ExportToExcel): Observable<HttpResponse<any>> {
    const url = apiEndpoints.exportWeeklySchedule;
    return this.httpUtilityService.post(url, data, {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept:
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      }),
    });
  }
}
